import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";

import { ShiftDetailsInnerCard } from "./InnerCard";

export function ShiftPaymentRequestCard() {
  return (
    <ShiftDetailsInnerCard>
      <CardContent>
        <Stack spacing={6} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="dollar-warning" />
          <Title semibold variant="h5" component="h3">
            Your shift payment
          </Title>
          <Text
            variant="body2"
            sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
          >
            Your shift is no longer InstantPay-eligible. Don&apos;t worry, you&apos;ll still be
            paid. Please request shift payment at the end of your shift.
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
